import { COUPON_CALLOUT_COMPONENT_FOR_EU_AND_ANZS } from './src-constants-featureFlags.js';
import { CSRWrapper } from './src-components-CSRWrapper-CSRWrapper.js';
import { CouponCalloutExtractionWrapper } from './src-components-CouponCalloutExtraction-CouponCalloutExtractionWrapper.js';
import { CouponErrorBoundary } from './src-components-CouponErrorBoundary-CouponErrorBoundary.js';
import React from 'react';
import { isLocaleEnabled } from './src-utils-locale.util.js';
import { pagesWithNoQtyCheck } from './src-constants-pageId.js';
import { useFeatureToggle } from './src-hooks-useFeatureToggle.js';
import { useScopedBaseConfig } from './src-contexts-CouponCalloutConfig.context.js';

const CouponCallout = (props) => {
  const { locale, pageId } = useScopedBaseConfig();
  const { isFeatureFlagEnabled } = useFeatureToggle();
  if (pagesWithNoQtyCheck.includes(pageId) && !props.quantity) return null;
  if (isLocaleEnabled(locale) || isFeatureFlagEnabled(COUPON_CALLOUT_COMPONENT_FOR_EU_AND_ANZS)) {
    return /* @__PURE__ */ React.createElement(CSRWrapper, null, /* @__PURE__ */ React.createElement(CouponErrorBoundary, null, /* @__PURE__ */ React.createElement(CouponCalloutExtractionWrapper, { ...props })));
  }
  return null;
};

export { CouponCallout };
//# sourceMappingURL=src-components-CouponCallout-CouponCallout.js.map
